import api from './api';
import { User } from '../types/user';

export const login = async (email: string, password: string):Promise<User> => {
  const response = await api.post('/auth/login', { email, password });
  return response.data.user;
};

export const logout = async (): Promise<{ message: string, logoutUrl?: string }> => {
  const response = await api.post('/auth/logout');
  return response.data;
};

export const checkAuthStatus = async (): Promise<{ isAuthenticated: boolean, user: User | null }> => {
  const response = await api.get('/auth/status');
  return response.data;
};

export const getAuthConfig = async (): Promise<{ authMethod: 'local' | 'oidc' }> => {
  try {
    const response = await api.get('/auth/config');
    return response.data;
  } catch (error) {
    console.error("Failed to fetch auth config", error);
    return { authMethod: 'local' };
  }
};

/** Completa il recupero: il token arriva dal link ricevuto via email. */
export const resetPassword = async (token: string, newPassword: string): Promise<void> => {
  await api.post('/auth/reset-password', { token, newPassword });
};

export const forgotPassword = async (email: string): Promise<void> => {
  await api.post('/auth/forgot-password', { email });
};
